var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17002 4.04228C7.87752 6.28514 6.67373 8.38862 6.47098 8.73075L6.12885 9.33898L8.97995 9.27563L11.641 4.39709L14.302 9.33898C16.6969 9.33898 17.0137 9.30097 16.9757 9.17425C16.9503 9.09822 15.7592 6.99475 14.3273 4.5238C12.8954 2.05285 11.679 0.0127376 11.6156 6.6056e-05C11.5649 -0.0126055 10.4625 1.79942 9.17002 4.04228ZM5.40657 10.6315C5.34322 10.7202 5.00109 11.3157 4.64628 11.9493C4.30415 12.5829 4.00004 13.1404 4.00004 13.1911C3.98736 13.2291 7.396 13.2672 11.5776 13.2672C15.7592 13.2672 19.2059 13.2291 19.2312 13.1785C19.2566 13.1151 18.9524 12.5069 18.547 11.8099L17.812 10.5428C6.85113 10.4794 5.49528 10.5174 5.40657 10.6315ZM6.28091 14.8384C6.30625 14.9525 7.48471 17.0559 8.91659 19.5269C10.3485 21.9978 11.5649 24.0126 11.6156 23.9999C11.6663 23.9873 12.9208 21.9218 14.3907 19.4255C15.8606 16.9166 17.0264 14.8258 16.9884 14.7624C16.9377 14.7117 16.3168 14.661 15.6072 14.661H14.302L11.641 19.6156L8.96727 14.7244C6.44564 14.661 6.2429 14.6864 6.28091 14.8384Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreon);
export default __webpack_public_path__ + "static/media/areon.1f32661d094c153962928db17df0ff69.svg";
export { ForwardRef as ReactComponent };